import { brand } from '../../fuse-colours/src/colours';
import { fontFamily } from '../../fuse-typography/src/typography';

const { very } = brand;

const defaultFontFamily = fontFamily.very;
const defaultLightColour = very.pinkLight;
const defaultMidColour = very.pinkMid;
const defaultDarkColour = very.pinkDark;

export { defaultLightColour, defaultMidColour, defaultDarkColour, defaultFontFamily };
